import React from 'react';

import cx from 'classnames';
import moment from 'moment';
import _ from "lodash";
import dateformat from 'dateformat';

import { Row, Col, Dropdown, FormControl } from 'react-bootstrap';

import { DATE_RANGES, TODAY, CUSTOM } from "../../../constants/report"
import { getReportDatesForOption, daysDifference } from "../../../services/report.service"

import styles from '../reports.module.scss';

import { localizedStrings } from '../../../../localization/index';
import DatePickerComponent from 'src/components/datePicker';

class ReportDatePicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      startDate: this.props.value.startDate,
      endDate: this.props.value.endDate,
      daysBetween: 0,
      activeTimelineFilter: ""
    }

    this.id = `report-date-picker-${new Date().getTime()}`;

    this.handleOptionSelection = this.handleOptionSelection.bind(this);
    this.handleToggleDropdown = this.handleToggleDropdown.bind(this);
    this.handleCustomDateChange = this.handleCustomDateChange.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);

    this.localizedReport = localizedStrings.pages.reports;

  }
  componentDidMount() {
    this.setState({
      activeTimelineFilter: _.get(this.props, "filter.interval", "day")
    })
  }

  componentWillReceiveProps(nextProps) {
    const daysBetween = daysDifference(_.get(nextProps, "value.startDate"), _.get(nextProps, "value.endDate"))
    this.setState({
      daysBetween,
      activeTimelineFilter: _.get(this.props, "filter.interval", "day")
    })

  }

  handleToggleDropdown(open) {
    this.setState({
      open: open,
      startDate: _.get(this.props.value, 'startDate') || moment(),
      endDate: _.get(this.props.value, 'endDate') || moment()
    });
  }

  handleOptionSelection(key) {
    this.props.onChange({
      type: key,
      ...getReportDatesForOption(key)
    })

    this.setState({
      open: false
    });
  }

  handleCustomDateChange() {
    this.props.onChange({
      type: CUSTOM,
      startDate: this.state.startDate,
      endDate: this.state.endDate
    });

    this.setState({
      open: false,
      startDate: moment(this.props.value),
      endDate: moment(this.props.value)
    });
  }

  renderLabel() {
    const type = _.get(this.props, 'value.type') || TODAY;

    if (type === CUSTOM) {
      const startDate = _.get(this.props.value, 'startDate') || moment();
      const endDate = _.get(this.props.value, 'endDate') || moment();

      return `${dateformat(startDate, 'dd/mm/yyyy')} - ${dateformat(endDate, 'dd/mm/yyyy')}`;
    }

    const option = DATE_RANGES.find(item => item.label === type);
    return option.value;
  }

  handleFilterChange(value) {
    const selectedTimeline = value;
    this.props.handleTimeLineChange(selectedTimeline)
    this.setState({
      activeTimelineFilter: selectedTimeline,
      open: false
    })
  }

  render() {

    const daysBetween = _.get(this.state, "daysBetween", 0)

    return (
      <Dropdown id={this.id}
        className={cx(styles.datepicker, this.props.className)}
        // rootCloseEvent='click'
        show={this.state.open}
        onToggle={this.handleToggleDropdown}
      >
        <Dropdown.Toggle className={styles.action}>{this.renderLabel()}
          <span className={styles.arrow}>
            <i className='paperflite-dropdown' />
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <div className={styles.options}>
            {DATE_RANGES.map(item => {
              const active = _.get(this.props.value, 'type') === item.label;
              return (
                <div
                  key={item.label}
                  className={cx(styles.option, {
                    [styles.active]: active
                  })}
                  onClick={() => this.handleOptionSelection(item.label)}
                >
                  {item.value}
                </div>
              )
            })}
          </div>
          <div className={styles.timelineFilter}>

            <div className={cx(styles.filter, {
              [styles.active]: _.get(this.state, "activeTimelineFilter") === "day",
              [styles.disabled]: daysBetween > 365
            })}>
              <i onClick={() => daysBetween < 365 && this.handleFilterChange("day")} className={cx(`${this.state.activeTimelineFilter === "day" ? 'paperflite-radio-button-selected' : 'paperflite-radio-button-unselected'}`)} aria-hidden="true"></i>
              <span>{this.localizedReport.filters.date.day}</span>
            </div>

            <div className={cx(styles.filter, {
              [styles.active]: _.get(this.state, "activeTimelineFilter") === "week",
              [styles.disabled]: daysBetween < 14
            })}>
              <i onClick={() => daysBetween >= 14 && this.handleFilterChange("week")} className={cx(`${this.state.activeTimelineFilter === "week" ? 'paperflite-radio-button-selected' : 'paperflite-radio-button-unselected'}`)} />
              <span>{this.localizedReport.filters.date.week}</span>
            </div>

            <div className={cx(styles.filter, {
              [styles.active]: _.get(this.state, "activeTimelineFilter") === "month",
              [styles.disabled]: daysBetween < 60
            })}>
              <i onClick={() => daysBetween >= 60 && this.handleFilterChange("month")} className={cx(`${this.state.activeTimelineFilter === "month" ? 'paperflite-radio-button-selected' : 'paperflite-radio-button-unselected'}`)} />
              <span>{this.localizedReport.filters.date.month}</span>
            </div>

          </div>

          <div className={styles.form}>
            <div className={cx(styles.date, styles.start)}>
              <label>{this.localizedReport.filters.date.start_date}: </label>
              <DateInput
                key={this.state.startDate}
                value={this.state.startDate}
                onChange={(value) => {
                  if (!value) {
                    return;
                  }
                  this.setState({
                    startDate: value,
                    endDate: moment.max(value, this.state.endDate)
                  })
                }} />
            </div>
            <div className={cx(styles.date, styles.end)}>
              <label>{this.localizedReport.filters.date.end_date}: </label>
              <DateInput
                key={this.state.endDate}
                value={this.state.endDate}
                onChange={(value) => {
                  if (!value) {
                    return;
                  }
                  this.setState({
                    startDate: moment.min(value, this.state.startDate),
                    endDate: value
                  })
                }} />
            </div>
            <button className={styles.submit} onClick={this.handleCustomDateChange}>{this.localizedReport.actions.apply}</button>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

class DateInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDate: this.props.value ? this.props.value._d : null
    };

    this.handleDateChange = this.handleDateChange.bind(this);
  }

  handleDateChange(date) {
    const formattedDate = moment(date);
    this.setState({
      selectedDate: date
    });

    this.props.onChange(formattedDate);
  }

  render() {
    return (
      <DatePickerComponent
        customInput={<FormControl type="text" onSelect={(e) => { e.stopPropagation(); }} />}
        value={this.state.selectedDate}
        handleDateChange={this.handleDateChange}
        maxDate={moment().add(5, "year").toDate()}
        minDate={moment().subtract(5, "year").toDate()}
      />
    );
  }
}

export default ReportDatePicker;    